// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: Bump in the channel/DM header (bump-plan.md section 3): the desktop row's icon button, or the
// phone-width row's, for channels that offer it; disabled while a bump runs and for 2 s after. Exclude from upstream
// sync.

import {BumpStrings} from '@app/features/bump/BumpStrings';
import {bump, canBump} from '@app/features/bump/commands/BumpCommands';
import ChannelBumps from '@app/features/bump/state/ChannelBumps';
import styles from '@app/features/channel/components/ChannelHeader.module.css';
import {ChannelHeaderIcon} from '@app/features/channel/components/channel_header_components/ChannelHeaderIcon';
import type {Channel} from '@app/features/channel/models/Channel';
import FocusRing from '@app/features/ui/focus_ring/FocusRing';
import {HandWavingIcon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';

export const BumpHeaderButton = observer(({channel, mobile = false}: {channel: Channel; mobile?: boolean}) => {
	if (!canBump(channel)) return null;
	const busy = ChannelBumps.isBusy(channel.id);
	const onClick = () => void bump(channel.id);
	if (mobile) {
		return (
			<FocusRing offset={-2} data-flx="bump.header-button-mobile.focus-ring">
				<button
					type="button"
					className={styles.iconButtonMobile}
					aria-label={BumpStrings.bump}
					disabled={busy}
					onClick={onClick}
					data-flx="bump.header-button-mobile"
				>
					<HandWavingIcon className={styles.buttonIconMobile} weight="bold" data-flx="bump.header-button-mobile.icon" />
				</button>
			</FocusRing>
		);
	}
	return (
		<ChannelHeaderIcon
			icon={HandWavingIcon}
			label={BumpStrings.bump}
			onClick={onClick}
			disabled={busy}
			data-flx="bump.header-button"
		/>
	);
});
